import React from 'react';
import { Button, Icon, Modal } from 'antd';
import cn from 'classnames';
import { useStateMethods } from '../../../providers/stateManager';
import { stateKeys } from '../../../constants/stateKeys';
import { groupAttachmentsByType } from '../../../../../helpers/attachments/groupByType';
import { useEvents } from '../../../providers/events';
import styles from './index.module.scss';

const Actions = ({ className, canEditComment, comment }) => {
  return (
    <div className={cn(styles.root, className)}>
      {canEditComment && <EditAction comment={comment} />}

      <RemoveAction comment={comment} />
    </div>
  );
};

export default Actions;

function EditAction({ comment }) {
  const { setState } = useStateMethods();

  const handleClick = () => {
    const { files, images } = groupAttachmentsByType(comment.attachments);

    setState({
      [stateKeys.editComment]: comment,
      [stateKeys.text]: comment.note,
      [stateKeys.files]: files,
      [stateKeys.images]: images,
    });
  };

  return (
    <Button className={styles.action} onClick={handleClick}>
      <Icon type="edit" />
    </Button>
  );
}

function RemoveAction({ comment }) {
  const { onDeleteComment } = useEvents();

  if (typeof onDeleteComment !== 'function') {
    return null;
  }

  const handleClick = () => {
    Modal.confirm({
      title: 'Вы действительно хотите удалить этот комментарий?',
      centered: true,
      content: 'Его нельзя будет восстановить.',
      async onOk() {
        await onDeleteComment(comment.id);
      },
      onCancel() {},
    });
  };

  return (
    <Button className={styles.action} onClick={handleClick}>
      <Icon type="delete" theme="filled" />
    </Button>
  );
}
